/**
 * Compact "time ago" label (just now, 5m/21h/3d/2w ago). Accepts ms, Date, or date string;
 * returns '' for falsy/invalid input.
 */
export function formatRelativeTime(input) {
  if (!input) {
    return '';
  }

  const ms = input instanceof Date ? input.getTime() : new Date(input).getTime();
  if (Number.isNaN(ms)) {
    return '';
  }

  const seconds = Math.floor((Date.now() - ms) / 1000);
  if (seconds < 60) {
    return 'just now';
  }

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes}m ago`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours}h ago`;
  }

  const days = Math.floor(hours / 24);
  if (days < 7) {
    return `${days}d ago`;
  }

  return `${Math.floor(days / 7)}w ago`;
}
